/**
 * Automation constants used to target elements
 * in unit + integration
 */
export const AUTOMATION_LOCATORS = {
  DESCRIPTION: 'Description',
  TAGS: 'Tags',
  TAG_ITEM: 'TagItem',
  TITLE: 'Title'
}
